export default "__VITE_ASSET__0ec0976a__"